<template>
  <div>
    <ExperimentAgreeSentence/>
    <TextLink text="同意して進む" @click-text="onClickAgree"/>
    <TextLink text="実験参加せず、利用開始する" @click-text="onClickNotAgree"/>
  </div>
</template>

<script>
import TextLink from '@/components/Atoms/TextLink'
import ExperimentAgreeSentence from '@/components/Molecules/ExperimentAgreeSentence'

export default {
  name: 'consetn-check',
  components: {
    TextLink,
    ExperimentAgreeSentence
  },
  methods: {
    onClickAgree () {
      this.$emit('click-ok', true)
    },
    onClickNotAgree () {
      this.$emit('click-ok', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Organisms/ExperimentAgreeCheck.vue